import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api, useAuth } from "../App";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);

        if (!sessionIdMatch) {
          setError("No session ID found");
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for session_token
        const response = await api.post("/auth/session", {
          session_id: sessionId,
        });

        const userData = response.data;

        // Login user
        login(userData);

        // Clear the hash and redirect
        window.history.replaceState(null, "", window.location.pathname);

        // Check if there was a redirect destination
        const from = location.state?.from || "/";
        navigate(from, { replace: true, state: { user: userData } });
      } catch (err) {
        console.error("Auth callback error:", err);
        setError("Error al procesar la autenticación");
        setTimeout(() => navigate("/login"), 2000);
      }
    };

    processAuth();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen bg-sand flex flex-col items-center justify-center">
        <div className="text-red-600 mb-4">{error}</div>
        <p className="text-gray-600">Redirigiendo al login...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-sand flex flex-col items-center justify-center">
      <Loader2 className="w-12 h-12 animate-spin text-terracotta mb-4" />
      <p className="text-gray-600">Completando inicio de sesión...</p>
    </div>
  );
}
